import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import FeaturePlatform from './Pages/FeaturePlatform';
import Dashboard from './Pages/Dashboard';
import Banner from './Pages/Banner';
import FAQs from './Pages/FAQs';
import ContactUs from './Pages/ContactUs';
import Deposit from './Pages/Deposit';
import Credit from './Pages/Credit';
import Promotions from './Pages/Promotions';
import AdminLogin from './Pages/AdminLogin';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn');
    setIsAuthenticated(loggedIn === 'true'); // Update the state based on the stored value
    console.log('Logged In:', loggedIn);
  }, []); 

  useEffect(() => {
    console.log('Authenticated state:', isAuthenticated);
  }, [isAuthenticated]); // This will log when isAuthenticated changes

  return (
    <Router>
      <Routes>
        {/* Redirect to Dashboard if authenticated, otherwise to Admin Login */}
        <Route path="/" element={<Navigate replace to={isAuthenticated ? "/Dashboard" : "/Admin-Login"} />} />

        {/* Public route for login */}
        <Route path="/Admin-Login" element={<AdminLogin setIsAuthenticated={setIsAuthenticated} />} />

        {/* Protected routes - only accessible if authenticated */}
        {isAuthenticated && (
          <Route element={<MainLayout />}>
            <Route path="Dashboard" element={<Dashboard />} />
            <Route path="FeaturePlatform" element={<FeaturePlatform />} />
            <Route path="Banner" element={<Banner />} />
            <Route path="FAQs" element={<FAQs />} />
            <Route path="ContactUs" element={<ContactUs />} />
            <Route path="Deposit" element={<Deposit />} />
            <Route path="Credit" element={<Credit />} />
            <Route path="Promotions" element={<Promotions />} />
          </Route>
        )}

        {/* Catch-all for non-existing routes */}
        <Route path="*" element={<Navigate replace to="/Admin-Login" />} />
      </Routes>
    </Router>
  );
}

export default App;
